import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectRelyingPartyId } from "@utils/parameter-injector";
import { RelyingPartyConfig } from "@idw-types/data/relying-party-config";

export const getRelyingPartyRequest = async (relyingPartyId: string): Promise<{ data: RelyingPartyConfig, error: any }> => {
    const route = injectRelyingPartyId(apiRoutes.axnadminCore.axn.relyingpartyWithId, relyingPartyId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};